<template>
    <div :class="action_type">
        <v-card-title  class="ma-0 pa-1 px-4">
            <span class="caption-font white--text"><v-icon size="30" color="white" class="pa-0 pb-2 pr-4">{{ action_avatar }}</v-icon>There are {{ actions.length }} accommodations with {{ action_type }} actions</span>
            <v-spacer></v-spacer>
            <v-btn v-if="actions.length>0&&!showDetails" color="primary" text small v-on:click="showDetails = !showDetails" class="mr-10 white--text"><v-icon color="primary">mdi-arrow-down-bold-box-outline</v-icon> View list</v-btn>
            <v-btn v-if="actions.length>0&&showDetails"  color="primary" text small v-on:click="showDetails = !showDetails" class="mr-10 white--text"><v-icon color="primary">mdi-arrow-down-bold-box-outline</v-icon> Hide list</v-btn>
        </v-card-title>
        <v-card-text v-if="showDetails">
            <v-row class="ma-0 pa-0">
                <v-col cols="1" class="acconame ma-0 pa-0">
                    Accommodation
                </v-col>
                <v-col cols="3" class="acconame ma-0 pa-0">
                    Name
                </v-col>
                <v-col cols="3" class="acconame ma-0 pa-0">
                    Rental expert
                </v-col>
                <v-col cols="1" class="acconame ma-0 pa-0">
                    Action date
                </v-col>
                <v-col cols="4" class="acconame ma-0 pa-0">
                    Action
                </v-col>
            </v-row>
            <v-divider/>
            <v-row v-for="item in actions" :key="item.huis_encrid" class="ma-0 pa-0">
                <v-col cols="1" class="ma-0 pa-0">
                    <span class="accolink blue--text text-decoration-underline" @click="openSubScreen('/huis/onhuis/' + item.huis_encrid)">{{ item.huis_code }}</span>
                </v-col>
                <v-col cols="3" class="acconame ma-0 pa-0">
                    {{ item.huis_naam }}
                </v-col>
                <v-col cols="3" class="acconame ma-0 pa-0">
                    {{ item.gebr_naam }}
                </v-col>
                <v-col cols="1" class="acconame ma-0 pa-0">
                    {{ item.actie_datum }}
                </v-col>
                <v-col cols="4" class="acconame ma-0 pa-0">
                    {{ item.actie_opm }}
                </v-col>
            </v-row>
        </v-card-text>
    </div>
</template>

<script>
    export default {
        props: {
            actions: {
                type: Array,
                required: true                
            },
            action_type: {
                type: String,
                required: true                
            },
            action_avatar: {
                type: String,
                required: true                
            },
        },
        data() {
            return {
                showDetails: false,
            }
        },
        mounted () {
            this.showDetails = false;
        },
        methods: {
            toggle() {
                this.showDetails = !this.showDetails
            },
            openSubScreen(path) {
                let route = this.$router.resolve({ path: path }); 
                window.open(route.href, '_blank');
            },          
        }
    }
</script>

<style scoped>
    .overdue {
        background-image: linear-gradient(#FF0000, #FF6600) !important;
        background-size: cover !important;
    }
    .upcoming {
        background-image: linear-gradient(#FF6600, #FFAA00) !important;
        background-size: cover !important;
    }
    .other {
        background-image: linear-gradient(#FFAA00, #FFFF00) !important;
        background-size: cover !important;
    }

    .change {
        background: transparent !important;
        font-size: 12px !important;
        font-weight: 600 !important;
        border: 2px solid white;
        color: white;
        cursor: default;
    }

    .caption-font {
        font-size: 30px;
        font-weight: bold;
    }

    .accolink {
        cursor: pointer;
    }

    .acconame {
        cursor: default;
    }

    .listHeader {
        font-weight: bold;
    }
</style>